import { fetchHouseHouseStylesIfNeeded } from '@/redux/modules/whitelabel';
import { getWhiteLabelUrlWithHouseId } from '@/utils/urls';
import { useAppDispatch } from '@/redux/hooks';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import HouseFinder from '../../components/HouseFinder/HouseFinder';

type Props = {
    setShowHouseStyles: Function;
};
const WhiteLabelHouseFinder = ({ setShowHouseStyles }: Props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const submitHouseId = useCallback(
        (houseId) => {
            navigate(getWhiteLabelUrlWithHouseId(houseId));
            dispatch(fetchHouseHouseStylesIfNeeded(houseId));
            setShowHouseStyles(true);
        },
        [dispatch, navigate, setShowHouseStyles]
    );

    return <HouseFinder submitHouseId={submitHouseId} />;
};

export default WhiteLabelHouseFinder;
